if (!customElements.get('cart-mobile-checkout')) {
  customElements.define('cart-mobile-checkout', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.initialize();
      });
    }

    initialize() {
      this.subtotal = this.closest('#AjaxCartSubtotal');
      this.primary = this.subtotal?.querySelector('#CheckOut');
      this.button = this.querySelector('button');
      if (!this.primary || !this.button) return;

      this.setVisible(false);
      this.hidden = false;
      this.mobile = window.matchMedia('(max-width: 1023px)');
      this.footer = document.querySelector('#main-footer, footer');
      this.mainContainer = document.querySelector('.kt-main-container');
      this.viewport = window.visualViewport;
      this.abortController = new AbortController();
      this.primaryVisible = true;
      this.sync = () => {
        const processing = this.subtotal.classList.contains('kt-processing');
        const viewportBottom = (this.viewport?.offsetTop || 0) + (this.viewport?.height || window.innerHeight);
        let footerVisible = false;
        if (this.footer?.isConnected) {
          const footerRect = this.footer.getBoundingClientRect();
          // A fixed footer is revealed as the main container scrolls away.
          const footerTop = getComputedStyle(this.footer).position === 'fixed' && this.mainContainer
            ? this.mainContainer.getBoundingClientRect().bottom
            : footerRect.top;
          footerVisible = footerRect.height > 0 && footerTop < viewportBottom;
        }
        this.setVisible(this.mobile.matches && !this.primaryVisible && !processing && !footerVisible);
        this.button.disabled = this.primary.disabled || processing;
      };
      this.schedule = () => {
        if (!this.isConnected || this.frame !== null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      };
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.primaryVisible = entries[0].isIntersecting;
        this.schedule();
      });
      this.visibilityObserver.observe(this.primary);
      this.stateObserver = new MutationObserver(this.schedule);
      this.stateObserver.observe(this.primary, { attributes: true, attributeFilter: ['disabled'] });
      this.stateObserver.observe(this.subtotal, { attributes: true, attributeFilter: ['class'] });
      this.stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      const signal = this.abortController.signal;
      this.mobile.addEventListener('change', this.schedule, { signal });
      for (const event of ['scroll', 'resize', 'orientationchange', 'pageshow']) {
        window.addEventListener(event, this.schedule, { passive: true, signal });
      }
      for (const event of ['scroll', 'resize']) {
        this.viewport?.addEventListener(event, this.schedule, { passive: true, signal });
      }
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.schedule);
        for (const element of [this.footer, this.mainContainer, document.body]) {
          if (element) this.resizeObserver.observe(element);
        }
      }
      this.sync();
    }

    setVisible(visible) {
      if (this.visible === visible) return;
      this.visible = visible;
      this.classList.toggle('kt-visible', visible);
      this.inert = !visible;
      this.setAttribute('aria-hidden', String(!visible));
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.abortController?.abort();
      this.visibilityObserver?.disconnect();
      this.stateObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.setVisible(false);
      this.hidden = true;
    }
  });
}
